import React from 'react';
import { Alert } from '@mui/material';
import { SampleInformationsDataGrid } from '../../components/SampleInformationsDataGrid';
import { useAuth } from '../../auth/AuthContext';
import { appDocumentTitle } from '../../appMeta';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { PageShell } from '../../layout/PageShell';
import { useSampleInformationsListQuery } from '../../query/hooks';

export function SampleInformationsPage() {
  const { jwt } = useAuth();
  const samplesQ = useSampleInformationsListQuery(jwt);

  useDocumentTitle(appDocumentTitle('Samples'));

  return (
    <PageShell
      title="Samples"
      subtitle="Kelola sampel. Hasil uji dan lampiran tampil di detail work order."
    >
      {!samplesQ.isPending && !samplesQ.isError && !samplesQ.data?.rows?.length ? (
        <Alert severity="info" sx={{ mb: 1, flexShrink: 0 }}>
          Belum ada sampel. Tambahkan dari work order atau saat membuat work order baru dari quotation.
        </Alert>
      ) : null}
      <SampleInformationsDataGrid
        rows={samplesQ.data?.rows ?? []}
        isLoading={samplesQ.isPending}
        isError={samplesQ.isError}
        error={samplesQ.error}
      />
    </PageShell>
  );
}
